import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { DiagnosisSection } from '../components/DiagnosisSection';
import { SystemSection } from '../components/SystemSection';
import { ResultsSection } from '../components/ResultsSection';
import { PartnersBadges } from '../components/PartnersBadges';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { ContactForm } from '../components/ContactForm';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-carbon w-full overflow-x-hidden selection:bg-gold selection:text-carbon" data-id="element-272">
      <HeroSection data-id="element-273" />
      <DiagnosisSection data-id="element-274" />
      <SystemSection data-id="element-275" />
      <ResultsSection data-id="element-276" />
      <PartnersBadges data-id="element-277" />
      <GuaranteeSection data-id="element-278" />
      <FAQSection data-id="element-279" />
      <ContactForm data-id="element-280" />
      <FinalCTA data-id="element-281" />
      <Footer data-id="element-282" />
    </main>;
}